module.exports = __webpack_public_path__ + "static/media/Valk2.f8af4df3.png";